import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { loadShareLink } from '../../../Helpers/ShareHelper';
import { LoadingScreen } from '../../shared';

export default function SharedPage() {
    const { code } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState('');

    useEffect(() => {
        if (!code) return;

        loadShareLink(code).then(data => {
            try {
                // Parse the stored data from the shortener
                const storedData = JSON.parse(data.data1);
                console.log('Shared data loaded:', storedData);

                if (!storedData.visualizer || !storedData.floorplan) {
                    throw new Error('Invalid shared data format');
                }

                // Restore persisted state to browser storage
                // Redux Persist will rehydrate from these on next load
                localStorage.setItem('persist:visualizer', storedData.visualizer);
                localStorage.setItem('persist:floorplan', storedData.floorplan);

                // Parse persisted data to get IDs for the URL
                // Redux Persist stores each field as a JSON string, so we need to parse them
                const visualizerData = JSON.parse(storedData.visualizer);

                const activeFloorplanId = typeof visualizerData.activeFloorplanId === 'string'
                    ? JSON.parse(visualizerData.activeFloorplanId)
                    : visualizerData.activeFloorplanId;

                const activeElevation = typeof visualizerData.activeElevation === 'string' 
                    ? JSON.parse(visualizerData.activeElevation) 
                    : visualizerData.activeElevation;

                const floorplanId = activeFloorplanId;
                const elevationId = activeElevation?.id;

                console.log('Navigating to visualizer:', { floorplanId, elevationId });

                // Full page reload so Redux Persist rehydrates from the storage we just set
                window.location.href = `/visualizer/${floorplanId}/${elevationId}`;
            } catch (err) {
                console.error('Error parsing shared data:', err);
                setError(err.message || 'Failed to load shared project');
            }
        }).catch(err => {
            console.error('Error loading share link:', err);
            setError(err.message || 'Failed to load shared project');
        });
    }, [code]);

    if (error) {
        return (
            <div style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                alignItems: 'center', 
                justifyContent: 'center', 
                minHeight: '100vh',
                padding: '20px',
                textAlign: 'center'
            }}>
                <h2>Error Loading Shared Project</h2>
                <p style={{ color: '#c33', marginTop: '10px' }}>{error}</p>
                <button 
                    onClick={() => navigate('/')}
                    style={{
                        marginTop: '20px',
                        padding: '10px 20px',
                        backgroundColor: '#2c5aa0',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    Go to Home
                </button>
            </div>
        );
    }

    return <LoadingScreen isOpen={true} message="Loading shared project..." />;
}
